module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('list', {
    attrs: {
      "listTitle": "Produtos",
      "listLogo": _vm.module.logo,
      "filterTitle": "Listagem de produtos",
      "loading": _vm.loading,
      "total": _vm.productsTotal,
      "sortFields": ['createdAt', 'title', 'brand'],
      "sortDefault": {
        field: 'createdAt',
        order: 'desc'
      }
    },
    on: {
      "change": _vm.onChange,
      "clearFilters": _vm.clearFilters
    }
  }, [_c('div', {
    attrs: {
      "slot": "top-actions"
    },
    slot: "top-actions"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md inline-flex"
  }, [_c('button', {
    staticClass: "hint hint--right btn btn--lg btn--default",
    attrs: {
      "data-label": "Selecionar todos"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll()
      }
    }
  }, [_c('i', {
    staticClass: "check-box",
    class: _vm.selectClass
  })]), _vm._v(" "), _c('bulk-actions', {
    attrs: {
      "actions": _vm.bulkActions,
      "icon": "icon-cloud-upload"
    },
    on: {
      "apply": _vm.applyBulkAction,
      "actions": _vm.updateActions
    }
  })], 1)])]), _vm._v(" "), _c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": "Código do produto"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-10@md"
  }, [_c('vue-tags-input', {
    staticClass: "form-input",
    attrs: {
      "tags": _vm.productCodes,
      "separators": [','],
      "add-on-key": [','],
      "placeholder": ""
    },
    on: {
      "tags-changed": function (newCodes) { return _vm.productCodes = newCodes; }
    },
    model: {
      value: (_vm.options.code),
      callback: function($$v) {
        _vm.$set(_vm.options, "code", $$v)
      },
      expression: "options.code"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-2@md u-textRight btn-dropdown"
  }, [_c('button-dropdown', {
    attrs: {
      "infos": _vm.configuresCodeType,
      "defaultOption": "contains"
    },
    on: {
      "change": function (type) { return _vm.options.codeType = type; }
    }
  })], 1)]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Utilize vírgula (,) para múltiplos códigos.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "EAN do produto"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.ean),
      expression: "options.ean"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.ean)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "ean", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Título do produto"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.title),
      expression: "options.title"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Marca"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brands,
      "selectLabel": "",
      "selectedLabel": "",
      "multiple": true,
      "placeholder": "Todas",
      "close-on-select": false
    },
    model: {
      value: (_vm.options.brand),
      callback: function($$v) {
        _vm.$set(_vm.options, "brand", $$v)
      },
      expression: "options.brand"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn--default count-selected hint hint--right",
    attrs: {
      "type": "button",
      "data-label": "Selecionar todas Marcas"
    },
    on: {
      "click": _vm.selectAllBrands
    }
  }, [_c('i', {
    staticClass: "icon icon-checkbox-checked colorButton"
  })])], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Categoria"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.categories,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Selecione"
    },
    model: {
      value: (_vm.options.category),
      callback: function($$v) {
        _vm.$set(_vm.options, "category", $$v)
      },
      expression: "options.category"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Status"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.status),
      expression: "options.status"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "waiting"
    }
  }, [_vm._v(_vm._s(_vm.$t('waiting.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "not_synchronized"
    }
  }, [_vm._v(_vm._s(_vm.$t('not_synchronized.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "synchronized"
    }
  }, [_vm._v(_vm._s(_vm.$t('synchronized.label')))])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Enviados"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-10@md"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.marketplaceSent),
      expression: "options.marketplaceSent"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "marketplaceSent", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.optionsMarketplaceSent()), function(module) {
    return _c('option', {
      key: module,
      domProps: {
        "value": module.identifier
      }
    }, [_vm._v(_vm._s(module.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "l-col-2@md u-textRight btn-dropdown"
  }, [_c('button-dropdown', {
    attrs: {
      "infos": _vm.configuresSent,
      "defaultOption": "partially",
      "disabled": _vm.options.marketplaceSent === null,
      "showHintDisabled": false
    },
    on: {
      "change": function (type) { return _vm.options.marketplaceSentType = type; }
    }
  })], 1)])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Ignorar variações sem imagem"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.hasImageInAllVariations),
      expression: "options.hasImageInAllVariations"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "hasImageInAllVariations", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Sim")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Ignorar variações sem estoque"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.hasStock),
      expression: "options.hasStock"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "hasStock", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Sim")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('productGroupedId.label')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.productId),
      expression: "options.productId"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.productId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "productId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Data de criação"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "format": "dd/MM/yyyy",
      "start-placeholder": "Data Inicial",
      "end-placeholder": "Data Final"
    },
    model: {
      value: (_vm.options.createdDate),
      callback: function($$v) {
        _vm.$set(_vm.options, "createdDate", $$v)
      },
      expression: "options.createdDate"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('manufacturerReference.label')
    }
  }, [_c('vue-tags-input', {
    staticClass: "form-input",
    attrs: {
      "tags": _vm.manufacturerReferenceTags,
      "separators": [','],
      "add-on-key": [','],
      "placeholder": ""
    },
    on: {
      "tags-changed": function (newTags) { return _vm.manufacturerReferenceTags = newTags; }
    },
    model: {
      value: (_vm.options.manufacturerReference),
      callback: function($$v) {
        _vm.$set(_vm.options, "manufacturerReference", $$v)
      },
      expression: "options.manufacturerReference"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Utilize vírgula (,) para múltiplas referências.")])], 1)], 1), _vm._v(" "), _vm._l((_vm.productsItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "l-col-12@md"
    }, [_c(_vm.productCardComponent, {
      ref: "items",
      refInFor: true,
      tag: "component",
      attrs: {
        "product": item
      }
    })], 1)
  }), _vm._v(" "), (!_vm.productsItems.length) ? _c('div', {
    staticClass: "l-col u-textCenter"
  }, [_c('panel', [_vm._v("\n        Nenhum produto encontrado.\n      ")])], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2588b8c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductProvide/List.vue
// module id = 2992
// module chunks = 0